import React, { useState, useEffect } from "react";
import { Form, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";

const ImageUploadField = ({ form, selectedItem, normFile, getDisplayUrl }) => {
  const fileList = Form.useWatch("file", form) || [];
  const newFile = fileList?.[0]?.originFileObj;
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (newFile) {
      const url = URL.createObjectURL(newFile);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    }
    setPreviewUrl(null);
  }, [newFile]);

  const hasExistingImage = selectedItem?.fileUrl && !newFile;
  const displayUrl = previewUrl || (hasExistingImage && getDisplayUrl ? getDisplayUrl(selectedItem.fileUrl) : null);
  const hasImage = !!displayUrl;

  return (
    <div className="input-white">
      <label className="text-description text-[#2F2B3DCC] font-medium">Image {!selectedItem?.fileUrl && "(Required)"}</label>
      <Form.Item
        name="file"
        valuePropName="fileList"
        getValueFromEvent={normFile}
        rules={[
          {
            validator: (_, fileList) => {
              if (!selectedItem?.fileUrl && (!fileList || fileList.length === 0)) {
                return Promise.reject(new Error("Please upload an image."));
              }
              if (fileList?.[0]?.originFileObj) {
                const file = fileList[0].originFileObj;
                const isImage = file.type?.startsWith("image/") || /\.(png|jpg|jpeg|gif|webp)$/i.test(file.name);
                if (!isImage) {
                  return Promise.reject(new Error("Please upload a valid image file (PNG, JPG, JPEG, GIF, WEBP)."));
                }
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Upload
          beforeUpload={() => false}
          maxCount={1}
          accept="image/*,.png,.jpg,.jpeg,.gif,.webp"
          showUploadList={false}
        >
          <div className="mt-2 rounded-lg border-2 border-dashed border-gray-200 bg-gray-50/50 overflow-hidden transition-all duration-200 hover:border-primary/50 hover:bg-gray-50 cursor-pointer group">
            {hasImage ? (
              <div className="p-3">
                <div className="flex flex-col sm:flex-row gap-3 items-center">
                  <div className="flex-shrink-0 w-full sm:w-36 h-24 rounded-md overflow-hidden bg-white border border-gray-100">
                    <img
                      src={displayUrl}
                      alt="Preview"
                      className="w-full h-full object-contain"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='64' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='1.5'%3E%3Crect x='3' y='3' width='18' height='18' rx='2'/%3E%3Ccircle cx='8.5' cy='8.5' r='1.5'/%3E%3Cpath d='m21 15-5-5L5 21'/%3E%3C/svg%3E";
                      }}
                    />
                  </div>
                  <div className="flex-1 flex flex-col justify-center min-w-0 w-full sm:w-auto">
                    {newFile && (
                      <p className="text-xs text-gray-600 truncate mb-1">
                        <span className="font-medium">Selected:</span> {newFile.name}
                      </p>
                    )}
                    {hasExistingImage && !newFile && (
                      <p className="text-xs text-gray-500 mb-1">Current unit image</p>
                    )}
                    <span className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-primary border border-primary/30 rounded-md bg-white group-hover:bg-primary/5 transition-colors w-fit">
                      <InboxOutlined />
                      Change Image
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-6 px-4">
                <div className="rounded-full bg-gray-100 p-2 mb-2 group-hover:bg-primary/10 transition-colors">
                  <InboxOutlined className="text-2xl text-gray-500 group-hover:text-primary transition-colors" />
                </div>
                <p className="text-xs font-medium text-gray-600 mb-0.5">Drop image here or click to browse</p>
                <p className="text-[11px] text-gray-400">jpg, jpeg, png, or svg</p>
              </div>
            )}
          </div>
        </Upload>
      </Form.Item>
    </div>
  );
};

export default ImageUploadField;
